import { render, staticRenderFns } from "./whatsNext.vue?vue&type=template&id=21f24734&scoped=true&"
import script from "./whatsNext.vue?vue&type=script&lang=js&"
export * from "./whatsNext.vue?vue&type=script&lang=js&"
import style0 from "./whatsNext.vue?vue&type=style&index=0&id=21f24734&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f24734",
  null
  
)

export default component.exports